import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Action, BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';

@Component({
  selector: 'app-akcija-update-modal',
  templateUrl: './akcija-update-modal.component.html',
  styleUrls: ['./akcija-update-modal.component.scss']
})
export class AkcijaUpdateModalComponent  extends BaseModalUpdateComponent<Action> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Action>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
